export default "__VITE_ASSET__Curqnnur__"